const DEFAULT_PROCESSING_FEE_BPS = 290;
const DEFAULT_PROCESSING_FEE_FIXED_CENTS = 30;

function envFlag(value, fallback = true) {
  const normalized = String(value ?? "").trim().toLowerCase();
  if (!normalized) return fallback;
  return !["0", "false", "no", "off"].includes(normalized);
}

function envNumber(value, fallback) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function shouldPassProcessingFees() {
  return envFlag(import.meta.env.VITE_STRIPE_PASS_PROCESSING_FEES, true);
}

export function getProcessingFeeConfig() {
  return {
    rateBps: Math.max(0, envNumber(import.meta.env.VITE_STRIPE_PROCESSING_FEE_BPS, DEFAULT_PROCESSING_FEE_BPS)),
    fixedCents: Math.max(0, envNumber(import.meta.env.VITE_STRIPE_PROCESSING_FEE_FIXED_CENTS, DEFAULT_PROCESSING_FEE_FIXED_CENTS)),
  };
}

export function calculateProcessingFeeCents(netAmountCents) {
  const amount = Math.max(0, Math.round(Number(netAmountCents || 0)));
  if (!shouldPassProcessingFees() || amount <= 0) return 0;

  const { rateBps, fixedCents } = getProcessingFeeConfig();
  const rate = rateBps / 10000;
  if (rate <= 0) return fixedCents;
  if (rate >= 0.95) return 0;

  const grossAmount = Math.ceil((amount + fixedCents) / (1 - rate));
  return Math.max(0, grossAmount - amount);
}

export function formatCents(amountCents, currency = "USD") {
  const amount = Number(amountCents || 0) / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
